import React from 'react';
import Chatbot from './pages/Chatbot';
import Home from './pages/Home';
import Landing from './pages/Landing';
import Results from './pages/Results';
import ResultsList from './pages/ResultsList';


function App() {
  const path = window.location.pathname;

  //route: /surveys/:id/results/:token
  const resultsMatch = path.match(/^\/surveys\/([^/]+)\/results\/([^/]+)$/);
  if (resultsMatch) {
    return <Results surveyId={resultsMatch[1]} sessionToken={resultsMatch[2]} />;
  }

  // /surveys/:id/chat/:token
  const chatMatch = path.match(/^\/surveys\/([^/]+)\/chat\/([^/]+)$/);
  if (chatMatch) {
    return <Chatbot surveyId={chatMatch[1]} sessionToken={chatMatch[2]} />;
  }

  // /surveys
  if (path === '/surveys' || path === '/surveys/') {
    return <Landing />;
  }

  // /results
  if (path === '/results' || path === '/results/') {
    return <ResultsList />;
  }

  // Secret export page
  const exportMatch = path.match(/^\/x7k9m2p4-export\/(\d+)$/);
  if (exportMatch) {
    const sid = exportMatch[1];
    const apiBase = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api');
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f1729' }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#fff', fontFamily: 'DM Serif Display, serif', marginBottom: 16 }}>Export Survey {sid}</h1>
          <a
            href={`${apiBase}/x7k9m2p4-export/${sid}`}
            style={{
              display: 'inline-block', padding: '12px 28px', background: '#fabc02', color: '#0f1729',
              borderRadius: 9999, fontWeight: 700, textDecoration: 'none', fontSize: 14,
            }}
          >
            Télécharger CSV
          </a>
        </div>
      </div>
    );
  }

  // /
  return <Home />;
}

export default App;
